import { render, staticRenderFns } from "./ChannelHome.vue?vue&type=template&id=52c86dc2&scoped=true&lang=pug&"
import script from "./ChannelHome.vue?vue&type=script&lang=js&"
export * from "./ChannelHome.vue?vue&type=script&lang=js&"
import style0 from "./ChannelHome.vue?vue&type=style&index=0&id=52c86dc2&lang=scss&scoped=true&"
import style1 from "./ChannelHome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c86dc2",
  null
  
)

export default component.exports